<template>
  <section id="Home" class="hero is-success is-fullheight">
    <div class="hero-body">
      <div class="container">
        <h1 class="has-text-centered">
          <b-image
            :src="require('@/assets/images/all-aboard.png')"
            alt="All aboard!"
          ></b-image>
        </h1>
        <Login v-if="!this.$store.getters.islogged"></Login>
        <button v-else></button>
      </div>
    </div>
  </section>
</template>

<script>
import Login from "@/components/Login.vue";
export default {
  name: "CaxtonHome",
  components: {
    Login
  }
};
</script>

<style scoped></style>
